import getTranslation from '@/locale/getTranslation'
export default [
  {
    path: '/web/staticImg/achievements',
    name: 'achievements',
    meta: {
      title: getTranslation('服贸会')
    },
    // 服务贸易成果展
    component: () => import('@/views/staticImg/achievements'),
  },
  {
    path: '/web/staticImg/countryExbition',
    name: 'countryExbition',
    meta: {
      title: getTranslation('服贸会')
    },
    component: () => import('@/views/staticImg/countryExbition'),
  },
  {
    path: '/web/staticImg/nationalExbition',
    name: 'nationalExbition',
    meta: {
      title: getTranslation('服贸会')
    },
    component: () => import('@/views/staticImg/nationalExbition'),
  },
  {
    path: '/web/staticImg/theme',
    name: 'staticImgTheme',
    meta: {
      title: getTranslation('服贸会')
    },
    component: () => import('@/views/staticImg/theme'),
  },
  {
    path: '/web/staticImg/environment',
    name: 'staticImgEnvironment',
    meta: {
      title: getTranslation('服贸会')
    },
    component: () => import('@/views/staticImg/environment'),
  }
]
